(function() {
  function initColorSwatches() {
    function handleSwatch(e) {
      const dot = e.target.closest('.tshirt-swatch-dot');
      if (!dot) return;

      if (e.type === 'click') {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
      }

      const card = dot.closest('.card-wrapper, .product-card-wrapper, .card');
      if (!card) return;

      // Update active dot
      const allDots = dot.closest('.tshirt-swatches-list')?.querySelectorAll('.tshirt-swatch-dot');
      if (allDots) {
        allDots.forEach(d => d.classList.remove('is-active'));
        dot.classList.add('is-active');
      }

      // Update card title link href to the specific variant
      const productUrl = dot.getAttribute('data-product-url');
      if (productUrl) {
        const cardLinks = card.querySelectorAll('.card__heading a, .card__inner a');
        cardLinks.forEach(link => {
          link.href = productUrl;
        });
      }

      // Swap image if variant image exists
      const imgUrl = dot.getAttribute('data-variant-img');
      if (imgUrl) {
        const cardMediaImg = card.querySelector('.card__media img');
        if (cardMediaImg) {
          cardMediaImg.src = imgUrl;
          cardMediaImg.srcset = imgUrl;
        }
      }
    }

    document.addEventListener('click', handleSwatch, true);
    document.addEventListener('mouseover', handleSwatch);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initColorSwatches);
  } else {
    initColorSwatches();
  }
})();
